<template>
  <md-content>
    <spinner :load="load" />
    <div v-if="!load">
      <div class="md-layout md-gutter md-alignment-center-left" style="margin-bottom: 15px">
        <div class="md-layout-item md-size-25">
          <span><b>{{ $t('settings.selectLang') }}</b></span>
        </div>
        <div class="md-layout-item md-size-75">
          <div class="flag-btn">
            <md-icon class="md-size-3x al-flag" @click.native="setLang('al')">
              <img v-if="$i18n.locale === 'al'" src="@/assets/icons/al.svg">
              <img v-else src="@/assets/icons/al_grey.svg">
            </md-icon>
            <md-icon class="md-size-3x en-flag" @click.native="setLang('en')">
              <img v-if="$i18n.locale === 'en'" src="@/assets/icons/en.svg">
              <img v-else src="@/assets/icons/en_grey.svg">
            </md-icon>
          </div>
        </div>
      </div>

      <md-divider></md-divider>

      <div class="md-layout md-gutter md-alignment-center-left erase-menu">
        <div class="md-layout-item md-size-50">
          <span><b>{{ $t('settings.updateDomains') }}</b></span>
        </div>
        <div class="md-layout-item md-size-50">
          <md-button @click="updateDomains()" class="md-raised md-primary erase-btn">{{ $t('global.update') }}</md-button>
        </div>
      </div>

      <md-divider></md-divider>

      <div class="md-layout md-gutter md-alignment-center-left erase-menu">
        <div class="md-layout-item md-size-50">
          <span><b>{{ $t('settings.eraseDb') }}</b></span>
        </div>
        <div class="md-layout-item md-size-50">
          <md-button @click="deleteDb(0)" class="md-raised md-primary erase-btn">{{ $t('global.delete') }}</md-button>
        </div>
      </div>

      <md-divider></md-divider>

      <div class="md-layout md-gutter md-alignment-center-left erase-menu">
        <div class="md-layout-item md-size-50">
          <span><b>{{ $t('settings.deleteTiles') }}</b></span>
        </div>
        <div class="md-layout-item md-size-50">
          <md-button class="md-primary md-raised erase-btn" @click="deleteDb(1)">{{ $t("global.delete") }}</md-button>
        </div>
      </div>

      <div class="md-layout md-gutter md-alignment-center-right vers">
        Vers {{ version }}
      </div>

      <md-dialog :md-active.sync="done" :md-fullscreen="false">
        <md-dialog-title v-if="db === 0">{{ $t('settings.eraseDbMsg') }}</md-dialog-title>
        <md-dialog-title v-else>{{ $t('settings.deleteTilesMsg') }}</md-dialog-title>
        <md-dialog-actions>
          <md-button class="md-primary" @click="eraseDb">{{ $t('global.yes') }}</md-button>
          <md-button class="md-primary" @click="done = false">{{ $t('global.no') }}</md-button>
        </md-dialog-actions>
      </md-dialog>
    </div>
  </md-content>
</template>

<script>
import Spinner from '@/components/Spinner'

import PouchDB from 'pouchdb'
import { setDomains } from '@/assets/scripts/domainsManager'

const version = require('@/../package').version

export default {
  props: ['measurements'],
  components: {
    Spinner
  },
  data: () => ({
    done: false,
    version: version,
    db: null,
    load: false
  }),
  mounted () {
    this.$emit('title', this.$i18n.t('home.settings'))
  },
  methods: {
    setLang: function (lang) {
      localStorage.lang = lang
      this.$i18n.locale = lang
      this.$emit('title', this.$i18n.t('home.settings'))
    },

    deleteDb: function (db) {
      this.db = db
      this.done = true
    },

    eraseDb: function () {
      this.load = true
      if (this.db === 0) {
        this.clear(this.measurements)
      } else {
        this.removeTiles()
      }
    },

    clear: function (db) {
      db.clear().then(() => {
        this.done = false
        this.load = false
      }).catch(err => {
        console.log(err)
      })
    },

    removeTiles: function () {
      new PouchDB('offline-tiles').destroy().then(() => {
        this.done = false
        this.load = false
      }).catch(err => {
        console.log(err)
      })
    },

    updateDomains: async function () {
      this.load = true
      await setDomains()
      this.load = false
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/arcadia_theme.scss';

  .al-flag {
    margin-left: 15px;
    margin-right: 5px;
  }

  .erase-menu {
    margin-top: 15px;
    margin-bottom: 15px;
  }

  .erase-btn {
    float: right;
  }

  .flag-btn {
    float: right;
    margin-right: 8px;
  }

  .vers {
    margin-top: 50px;
    font-weight: 500;
    margin-right: 8px !important;
  }
</style>
